class Route {
    constructor(parameters) {
        // --- Alap route mezők (Vue Router route record) ---
        this.name = parameters.name ?? null; // route neve
        this.path = parameters.path ?? null; // route útvonala
        this.component = parameters.component ?? null; // betöltendő komponens
        this.children = parameters.children ?? null;  // gyerek route-ok

        // --- Navigációs guardok ---

        // Route record szintű guard (Vue Router natívan támogatja)
        this.beforeEnter = parameters.beforeEnter ?? null;

        // Komponens szintű guardok
        // Ezek a Vue-ben alapvetően a komponensben definiálandók
        // (beforeRouteEnter, beforeRouteLeave, beforeRouteUpdate).
        // Itt csak konfigurációként kerülnek eltárolásra,
        // és kizárólag akkor működnek, ha a router setup külön kezeli őket.
        this.beforeRouteEnter = parameters.beforeRouteEnter ?? null;
        this.beforeRouteLeave = parameters.beforeRouteLeave ?? null;
        this.beforeRouteUpdate = parameters.beforeRouteUpdate ?? null;

        this.meta = {
            // --- UI / jogosultság / menü meta adatok (saját konvenció) ---
            hidden: parameters.hidden ?? false, // menüből elrejtés
            roles: parameters.roles ?? [],  // role alapú hozzáférés
            permissions: parameters.permissions ?? [], // permission alapú hozzáférés
            label: parameters.label ?? null, // menü/címke
            translate: true, // translate label

            // --- Ikon / extra komponensek (saját UI konvenció) ---
            iconBefore: parameters.iconBefore ?? null, // SVG ikon, ha definiált - a label előtt
            iconAfter: parameters.iconAfter ?? null, // SVG ikon, ha definiált - a label után
            componentBefore: parameters.componentBefore ?? null, // Csak akkor jelenik meg, ha van componentBefore definiálva - extra komponens előtte
            componentAfter: parameters.componentAfter ?? null, // Csak akkor jelenik meg, ha van componentAfter definiálva - extra komponens utána

            // --- Globális router hookok (meta-ban tárolva) ---
            // Ezek nem standard route-record mezők.
            // A Vue Router globális hookjai normálisan a router példányon
            // kerülnek regisztrálásra (router.beforeEach, router.beforeResolve, router.afterEach).
            // Itt csak konfigurációként vannak eltárolva, és kizárólag akkor
            // futnak le, ha a router inicializálás során külön kiolvassátok
            // és regisztráljátok őket.

            beforeEach: parameters.beforeEach ?? null, // beforeEach
            beforeResolve: parameters.beforeResolve ?? null, // beforeResolve
            afterResolved: parameters.afterResolved ?? null // afterEach
        };
    }
}

class RedirectRoute {
    constructor(parameters) {
        // --- Redirect route record ---
        this.name = parameters.name ?? null;
        this.path = parameters.path ?? null;
        this.redirect = parameters.redirect;

        this.meta = {
            hidden: parameters.hidden ?? true,  // redirecteket alapból rejteni szokás
            roles: parameters.roles ?? [],
            permissions: parameters.permissions ?? [],
            label: parameters.label ?? null,
            translate: true, // translate label
            iconBefore: parameters.iconBefore ?? null, // SVG ikon, ha definiált
            iconAfter: parameters.iconAfter ?? null, // SVG ikon, ha definiált
        };
    }
}

export {
    Route,
    RedirectRoute
};
